<template>
    <div>
        <div>
            <div class="row">
                <div 
                    class="col-xs-6 col-sm-4 col-md-3 item-group pointer" 
                    :class="{'width20':$store.state.innerWidth>1100}" 
                    v-on:click="goToDetail(occupation)" 
                    v-for="(occupation,index) in occupations"
                >
                    <a class="displayA" v-bind:href='"/occupationDetails/" + occupation.id+"?lang="+$store.state.language'></a>
                    <div class="g-group">
                        <img v-bind:src="occupation.imageCode" v-if="!magazineId" :alt="$store.getters.getContent(occupation.title)"  />
                        <img v-bind:src="occupation.imageCode" v-else :alt="$store.getters.getObject(occupation.langMap).title" />

                        <div class="title titleJia SemiBold wrap" v-if="!magazineId">
                            <a href="javascript:;" style="color: inherit">{{$store.getters.getContent(occupation.title)}}</a>
                        </div>
                        <div class="title titleJia SemiBold wrap" v-else>
                            <a href="javascript:;" style="color: inherit">{{$store.getters.getObject(occupation.langMap).title}}</a>
                        </div>
                    </div>
                </div>
                <div class="noResult" v-if="occupations.length==0&&isEnd">
                    {{$t('message.noSearchResult')}}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
			return {
					// list:[1,2,3,4,5,6,7,8],
					totalRows: 0,
					occupations: [],
					isEnd:false,

			}
    },
    props: [
			'jobFunctionId',
			'keyword',
			'educationLevel',
			'childLogGaEvent',
			'jobFunctionCode',
			'magazineId',
			'callback',
			'jobId',
			'courseKey',
    ],
    methods: {
			getOccupationList: function() {
				let Base64 = require('js-base64').Base64
				let that = this
				let postData = {}
				if (this.jobFunctionId) {
						postData.jobFunctionId = this.jobFunctionId
				}
				if (this.keyword) {
						postData.keyword = Base64.encode(this.keyword);
				}
				if (this.educationLevel) {
						postData.educationLevel = this.educationLevel
				}
				that.isEnd = false;
				this.api.getOccupationList(postData, function(data) {
						that.totalRows = data.totalRows;
						that.occupations = data.result;
						that.isEnd = true;
						if(that.callback){
								that.callback();
						}
						// 
				})
			},
			getArticleDetail: function() {
				var that = this;
				this.api.getArticleDetail(
					{
						articleId: that.magazineId
					},
					function(data) {
							that.occupations = data.result.occupationList;
					}
				);
			},
			getAllJobOccupationList: function(id) {
				if (!id || id == -1) return;
				let Base64 = require('js-base64').Base64;
				let that = this;
				let obj = {
					jobId: decodeURIComponent(id),
					keyword: Base64.encode(this.keyword),
					educationLevel: this.educationLevel,
					startRow: 0,
					maxRows: 1000,
				}
				that.isEnd = false;
				this.api.getAllJobOccupationList(obj, function(data) {
						that.occupations = data.result;
						that.isEnd = true;
				})
			},
			getAllCourseOccupationList: function(key) {
				if (!key || key == -1) return;
				let Base64 = require('js-base64').Base64;
				let that = this;
				let obj = {
					courseKey: key,
					keyword: Base64.encode(this.keyword),
					educationLevel: this.educationLevel,
					startRow: 0,
					maxRows: 1000,
				}
				that.isEnd = false;
				this.api.getAllCourseOccupationList(obj, function(data) {
						that.occupations = data.result;
						that.isEnd = true;
				})
			}
    },
    mounted() {
      // 
			if(this.$route.path.indexOf('magazine/')>0) return;
			if(this.magazineId){
				this.getArticleDetail()
			} else if (this.jobId){
				this.getAllJobOccupationList(this.$store.state.formData.jobId)
			} else if (this.courseKey) {
				this.getAllCourseOccupationList(this.$store.state.formData.courseKey)
			} else {
				this.getOccupationList()
			}

			this.goToDetail = function(item) {
				this.$store.state.occupationsFilter = {
					keyword:this.keyword,
					educationLevel:this.educationLevel
				}
				this.childLogGaEvent('userClick','occupation',this.$store.getters.getContent(item.title))
				this.$router.push({
					path:'/occupationDetails/' + item.id,
					query:{
						"lang":this.$store.state.language,
						"name":this.$store.getters.replaceEvent(this.$store.getters.getContent(item.title))
					}
				})
			}
    },
    watch: {
			keyword: function(n, o) {
				if(this.jobId) {
					this.getAllJobOccupationList(this.jobId)
				} else if(this.courseKey) {
					this.getAllCourseOccupationList(this.$store.state.formData.courseKey)
				} else {
					this.getOccupationList()
				}
			},
			educationLevel: function(n, o) {
				if(this.jobId) {
					this.getAllJobOccupationList(this.jobId)
				} else if(this.courseKey) {
					this.getAllCourseOccupationList(this.$store.state.formData.courseKey)
				} else {
					this.getOccupationList()
				}
			},
			jobFunctionId: function(n, o) {
				this.getOccupationList()
			},
			jobId: function(n, o) {
				this.getAllJobOccupationList(n)
			},
			courseKey: function(n, o) {
				this.getAllCourseOccupationList(n)
			}
    }
}
</script>